











































































import { Component, Ref, Watch, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import ChoiceListInput from '@/components/Lists/ChoiceListInput.vue';
import CardTitle from '@/components/common/CardTitle.vue';
import Decisions from "@/store/modules/Decisions";
import { getModule } from "vuex-module-decorators";
import { Choice } from '@/api/model/Choice';

const decisionsModule = getModule(Decisions);

@Component({
    components: { ChoiceListInput, CardTitle },
})
export default class ChoiceListInputDialog extends Vue {
    // mdi-file-outline
    @Prop({ default: 'mdi-file-outline', type: String })
    iconName!: string;

    @Prop({ default: '', type: String })
    btnText!: string;

    @Prop({ default: '', type: String })
    btnClass!: string;

    @Prop({ default: true, type: Boolean })
    icon!: boolean;

    @Prop({ default: true, type: Boolean })
    small!: boolean;

    @Prop({default: ()=>([]), type: Array})
    choicesFromParent!: Choice[]

    @Prop({default: false, type: Boolean})
    listActivator!: boolean

    @Prop({default: false, type: Boolean})
    skipActivator!: boolean

    @Prop({default: false, type: Boolean})
    open!: boolean

    private save = false;
    private saveAsNew = false;
    private clear = false;
    private loading = false;
    private show = false;
    private editing = false;

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    @Watch('open')
    private watchOpen() {
        this.show = this.open
        this.editing = false;
    }

    @Watch('show')
    private watchShow() {
        this.editing = false;
    }
    
    private saveChoice() {
        this.save = true;
        this.loading = true;
        this.$emit('close');
    }

    private saveChoiceAsNew() {
        this.saveAsNew = true;
        this.loading = true;
        this.$emit('close');
        this.editing = false;
    }

    private cancel() {
        this.clear = true;
        this.show = false;
        this.$emit('close');
    }

    private clearChoice() {
        this.clear = true;
        this.editing = false;
    }
}
